import React, { useId } from "react";

import * as UI from "./ui";
import { isPresent } from "../../lib/presence";

const Field = ({ label, value, type, required, onChange, weight, errors, touched, maxLength = null, persistErrors = false }) => {
  const id = useId();
  const [isBlurred, setIsBlurred] = React.useState(false);
  const showErrors = isBlurred || touched;

  return (
    <UI.FieldLayout weight={weight}>
      <UI.FieldBody>
        <UI.Input id={id} value={value} onChange={onChange} onBlur={() => setIsBlurred(true)} $invalid={showErrors && isPresent(errors)} required={required} type={type} maxLength={maxLength} autoComplete="disable-autocomplete-heuristic" />
        <UI.Label htmlFor={id} empty={!value}>{label}</UI.Label>
        {isPresent(errors) && showErrors && (
          <UI.Errors $persistErrors={persistErrors}>
            {errors}
          </UI.Errors>
        )}
      </UI.FieldBody>
    </UI.FieldLayout>
  );
}

export default Field;

